/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Pc_Dl_Steps_TitleInputs */

const en_pc_dl_steps_title = /** @type {(inputs: Pc_Dl_Steps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How to install PdfCraft on ${i?.platform}`)
};

const zh_pc_dl_steps_title = /** @type {(inputs: Pc_Dl_Steps_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在 ${i?.platform} 上安装 PdfCraft`)
};

/**
* | output |
* | --- |
* | "How to install PdfCraft on {platform}" |
*
* @param {Pc_Dl_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_steps_title = /** @type {((inputs: Pc_Dl_Steps_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Steps_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_steps_title(inputs)
	return zh_pc_dl_steps_title(inputs)
});
export { pc_dl_steps_title as "pc.dl.steps_title" }